import {
  IMergedSection,
  IReceivedRackTable,
  TypePartialRackItem,
} from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";
import { PostRequest } from "./http/BaseRequest";
import {
  BaseResponse,
  RecordResponse,
  RecordsResponse,
} from "./http/responses/BaseResponse";
import { IAvailableRack } from "@store/availableLocationRacks/actionTypes";
import {
  EQUIPMENT_TYPE,
  IAvailableEquipment,
  IWorkEquipment,
} from "@store/Equipments/actionTypes";
import { IRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";
import buildFormData from "@utils/buildFormData";
import W2UiFilterBuilder from "./w2ui";
import { SearchItem } from "./w2ui/w2const";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { castResponse } from "@utils/hooks/useTypedRequest";

export interface AddRackRecord {
  readonly id: string;
  readonly rack_id: string;
  readonly rack_items: TypePartialRackItem[];
}
export interface AddRackResponse extends RecordResponse<AddRackRecord> { }

/*extends BaseResponse {
  readonly Record: {
    readonly id: string;
    readonly rack_id: string;
    readonly rack_items: TypePartialRackItem[];
  };
}*/

export interface IAddRackParams {
  readonly location_id: string;
  readonly object_id: string;
  readonly template_id: string;
  readonly x: number;
  readonly y: number;
}

// @Request
export class AddRack extends PostRequest {
  constructor(params: IAddRackParams) {
    super(`/admin/rack/add`, { ...params });
  }
}
/*
export interface RackListResponse extends BaseResponse {
  Records: IReceivedRackTable[];
  Undo?: boolean;
  Redo?: boolean;
}
новая версия ниже 
*/
export interface RackListResponse extends RecordsResponse<IReceivedRackTable> {
  Undo?: boolean;
  Redo?: boolean;
}

export interface IGetRackListParams {
  readonly location_id: string;
  readonly object_id: string;
  readonly search?: string;
  readonly status?: MINER_STATUSES_E;
}

// @Request
export class GetRackList extends PostRequest {
  constructor(params: IGetRackListParams) {
    const { location_id, object_id, search, status } = params;
    const builder = new W2UiFilterBuilder();
    /*
      builder.setSearch([
        SearchItem.intIs("location_id", location_id),
        SearchItem.intIs("object_id", object_id),
      ]);
    */
    if (search && typeof search === "string") {
      builder.addSearch(
        SearchItem.textContains("searching", search.replaceAll("-", ""))
      );
    }
    if (status !== undefined) {
      builder.addSearch(SearchItem.intIs("status", status));
    }
    let p = builder.build().stringParams;
    p +=
      (p === "" ? "" : "&") +
      `location_id=${location_id}&object_id=${object_id}`;
    super(`/admin/rack/list2`, p);
  }
}

export class OperateRacksHistory extends PostRequest {
  constructor(undo: boolean) {
    super(`/admin/${undo ? "undo" : "redo"}`, {});
  }
}

export interface IUpdateRackPosition {
  id: string;
  x: number;
  y: number;
}

// @Request
export class DeleteRack extends PostRequest {
  constructor(id: string) {
    super(`/admin/rack/delete`, { id });
  }
}

export interface EditRackRecord {
  rack_items: TypePartialRackItem[];
}

export interface EditRackResponse extends RecordResponse<EditRackRecord> { }
interface IEditRackParams {
  readonly rack_items: string;
  readonly rack_type: string;
  readonly id: string;
}
export class EditRack extends PostRequest {
  constructor(params: IEditRackParams) {
    const data = buildFormData(params);
    super(`/admin/rack/update`, data);
  }
}

export interface TemplateListResponse extends BaseResponse {
  Records: IAvailableRack[];
}

export class GetRackTemplatesList extends PostRequest {
  constructor() {
    super(`/admin/rack/template/list`, {});
  }
}

export interface AddTemplateResponse extends RecordResponse<string> { }

export interface IAddRackTemplateParams {
  // readonly location_id: string;
  // readonly object_id: string;
  readonly rack_type: string; // - размер шаблона
  readonly rack_items: string;
}

export class AddRackTemplate extends PostRequest {
  constructor(params: IAddRackTemplateParams) {
    super(`/admin/rack/template/add`, {
      ...params,
    });
  }
}

// @Request
export class DeleteRackTemplate extends PostRequest {
  constructor(template_id: string) {
    super(`/admin/rack/template/delete`, {
      template_id,
    });
  }
}

export class EditRackTemplate extends PostRequest {
  constructor(params: IEditRackParams) {
    super(`/admin/rack/template/update`, {
      ...params,
    });
  }
}
/*
export interface GetObjectResponseRecordsArray extends BaseResponse {
  readonly Records: IBuildingName[];
}
*/
// @Request
export class GetObjectList extends PostRequest {
  constructor(location_id: string) {
    super(`/admin/object/list`, {
      location_id,
    });
  }
}
/*
export interface AddObjectResponseRecord extends BaseResponse {
  readonly Record: string; // -- id
}
*/
export interface IAddObjectParams {
  readonly location_id: string;
  readonly name: string;
}
// export class AddObject extends PostRequest {
//   constructor(params: IAddObjectParams) {
//     super(`/admin/object/add`, {
//       ...params,
//     });
//   }
// }

interface ObjectMeta {
  ElectricScheme: unknown;
}

export interface ObjectUpdateParams {
  readonly id: string;
  readonly name?: string;
  readonly meta?: string | ObjectMeta;
}
export class EditObject extends PostRequest {
  constructor(params: ObjectUpdateParams) {
    if (params.meta !== undefined && typeof params.meta !== "string") {
      params = {
        ...params,
        meta: JSON.stringify(params.meta),
      };
    }
    super(`/admin/object/update`, {
      ...params,
    });
  }
}

export const EditObjectTyped = {
  makeRequest(id: string, name?: string, meta?: string | ObjectMeta) {
    let params: ObjectUpdateParams = { id, name, meta };
    if (meta !== undefined && typeof meta !== "string") {
      params = {
        ...params,
        meta: JSON.stringify(params.meta),
      };
    }
    return new PostRequest(`/admin/object/update`, { ...params });
  },
};

export interface ObjectResponse {
  id: string;
  name: string;
  location_id?: string;
  meta: ObjectMeta;
  m_low?: number;
  m_offline?: number;
  m_online?: number;
  speed?: number;
  ord?: number;
}

export const isObjectResponse = (obj: object): obj is ObjectResponse =>
  obj &&
  (obj as ObjectResponse).meta !== undefined &&
  (obj as ObjectResponse).name !== undefined;

export interface IBuildingInfo extends ObjectResponse { }

export const GetObject = {
  makeRequest(objectID: number) {
    return new PostRequest("/admin/object/get", { id: objectID });
  },
  makeResponse: castResponse<RecordResponse<ObjectResponse>>,
};

export class DeleteObject extends PostRequest {
  constructor(id: string) {
    super(`/admin/object/delete`, {
      id,
    });
  }
}

export interface AvailableEquipmentsResponse extends BaseResponse {
  readonly Record: IAvailableEquipment[];
}

export class AvailableEquipmentsList extends PostRequest {
  constructor() {
    super(`/admin/equipments/template/list`, {});
  }
}

export interface AddAvailableEquipmentResponse extends RecordResponse<string> { }
export interface IAddAvailableEquipmentsParams
  extends Omit<IAvailableEquipment, "id"> { }
export class AddEquipments extends PostRequest {
  constructor(params: IAddAvailableEquipmentsParams) {
    super(`/admin/equipments/template/add`, { ...params });
  }
}

export interface IEditAvailableEquipmentParams extends IAvailableEquipment { }
export class EditEquipments extends PostRequest {
  constructor(params: IEditAvailableEquipmentParams) {
    super(`/admin/equipments/template/update`, { ...params });
  }
}

export class DeleteAvailableEquipments extends PostRequest {
  constructor(id: string) {
    super(`/admin/equipments/template/delete`, { id });
  }
}

export interface GetWorkEquipmentResponse extends BaseResponse {
  readonly Record: IWorkEquipment[];
}
export interface IWorkEquipmentsListParams {
  readonly location_id: string;
  readonly object_id: string;
}

export class GetWorkEquipments extends PostRequest {
  constructor(params: IWorkEquipmentsListParams) {
    super(`/admin/equipments/list`, { ...params });
  }
}

export interface AddWorkEquipmentResponse
  extends RecordResponse<Omit<IWorkEquipment, "notes" | "type" | "name">> { }

export interface IAddWorkEquipmentParams {
  readonly id: string; // - ID of template
  readonly location_id: string;
  readonly object_id: string;
}

export class AddWorkEquipments extends PostRequest {
  constructor(params: IAddWorkEquipmentParams) {
    // const user_color = getRandomColor();
    super(`/admin/equipments/add`, { ...params });
  }
}

export interface EditWorkEquipmentParams extends IAvailableEquipment { }
export class EditWorkEquipments extends PostRequest {
  constructor(params: EditWorkEquipmentParams) {
    super(`/admin/equipments/update`, { ...params });
  }
}
export class DeleteWorkEquipments extends PostRequest {
  constructor(id: string) {
    super(`/admin/equipments/delete`, { id });
  }
}
/*
export interface UnrackListResponse extends BaseResponse {
  readonly Records: IUnrackItem[];
}
*/

export interface UnrackListArgs {
  limit?: number;
  offset?: number;
  search?: string;
  status?: MINER_STATUSES_E;
}

export class GetUnrackList extends PostRequest {
  constructor(args: UnrackListArgs) {
    const { limit = 100, offset = 0, search, status } = args;
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
    if (search && typeof search === "string") {
      builder.setSearch([
        SearchItem.textContains("searching", search.replaceAll("-", "")),
      ]);
    }
    if (status !== undefined) {
      builder.addSearch(SearchItem.intIs("status", status));
    }
    const params = builder.build().stringParams;
    super(`/admin/unrack/list`, params);
  }
}

/*
export interface MoveUnrackItemResponse extends BaseResponse {
  readonly Record: IRackItem;
}
*/

export class MoveUnrackItem extends PostRequest {
  constructor(id: string, rack_item_id: string) {
    super(`/admin/unrack/move`, { id, rack_item_id });
  }
}

export interface MergeRackItemResponse extends BaseResponse {
  readonly Record: IRackItem;
}
export class MergeRackItem extends PostRequest {
  constructor(id: string, merge_id: string) {
    super(`/admin/rack/item/merge`, { id, merge_id });
  }
}
export class UnmergeRackItem extends PostRequest {
  constructor(id: string) {
    super(`/admin/rack/item/unmerge`, { id });
  }
}

export interface IMoveRackItemsRecord {
  rack_items: [IRackItem, ...IMergedSection[]];
}
/*
export interface MoveRackItemResponse extends BaseResponse {
  readonly Record: IMoveRackItemsRecord; 
}*/

export class MoveRackItem extends PostRequest {
  constructor(id: string, to_items: string) {
    const data = buildFormData({ id, to_items });
    super(`/admin/rack/item/move`, data);
  }
}
/*
export interface BackRackItemResponse extends BaseResponse {
  Record: string; // id
}
*/
export class BackRackItemToUnrack extends PostRequest {
  constructor(id: string) {
    super(`/admin/unrack/back`, { id });
  }
}

export class AddEquipmentToRackItem extends PostRequest {
  constructor(id: string, equipment_id: string) {
    super(`/admin/rack/item/update`, { id, equipment_id });
  }
}

export class DeleteEquipmentFromRackItem extends PostRequest {
  constructor(id: string, equipment_id: string) {
    super(`/admin/rack/item/update`, { id, equipment_id, rem: true });
  }
}

export class AddEquipmentInfoToRackItem extends PostRequest {
  constructor(id: string, type: EQUIPMENT_TYPE, info: string) {
    super(`/admin/rack/item/update`, { id, type, info: info });
  }
}

export class DeleteEquipmentInfoFromRackItem extends PostRequest {
  constructor(id: string, type: EQUIPMENT_TYPE) {
    super(`/admin/rack/item/update`, { id, type, info: "" });
  }
}

export class EditUserColor extends PostRequest {
  constructor(id: string, color: string) {
    super(`/admin/user/color`, { id, color });
  }
}

export interface ILocationByNameParams {
  readonly miner_id: string;
  readonly location: string;
  readonly object: string;
  readonly rack_id: string;
  readonly letter: string;
  readonly x: number;
  readonly y: number;
}
/*
export interface MinerLocationByNameResponseRecordString extends BaseResponse {
  readonly Record: string;
}*/
export class SetMinerLocationByName extends PostRequest {
  constructor(params: ILocationByNameParams) {
    super(`/admin/rack/item/add`, params);
  }
}

export class UpdateRackId extends PostRequest {
  constructor(params: { id: string; rackid: number }) {
    super("admin/rack/update/rackid", params);
  }
}
